import { medRequestStatusLabelToValue } from '@/constants/statuses'

export const CLINICAL_REVIEW_STATUS = medRequestStatusLabelToValue('Clinical Review') ?? 'wc-item-clinical-review'

// Stages from which the PHP item workflows accept a transition to wc-item-clinical-review.
// Source: e-pharmacy-api/library/order/workflows.php.
export const STAGES_ALLOWING_CLINICAL_REVIEW: ReadonlySet<string> = new Set([
  'wc-item-created',
  'wc-item-system-scr-check',
  'wc-item-decision-assistant-check',
  'wc-item-system-fan-check',
  'wc-item-clinical-query',
  'wc-item-clinical-fan',
  'wc-item-clinical-video',
  'wc-item-ready-for-fulfillment',
  'wc-item-pharmacist-check',
  'wc-item-picked',
  'wc-item-dispensed',
  'wc-item-packed'
])

export function normalizeMedRequestStageValue(stage: string): string {
  return stage.startsWith('wc-') ? stage : (medRequestStatusLabelToValue(stage) ?? stage)
}

export interface OnHoldEditSnapshot {
  reason: string
  patientResponse: string
}

export function getAutoAdvanceDecision({
  baseline,
  next,
  currentStageValue
}: {
  baseline: OnHoldEditSnapshot
  next: OnHoldEditSnapshot
  currentStageValue: string
}) {
  const hasManualChange =
    baseline.reason.trim() !== next.reason.trim() || baseline.patientResponse.trim() !== next.patientResponse.trim()
  const stageValue = normalizeMedRequestStageValue(currentStageValue)
  const inWhitelist = STAGES_ALLOWING_CLINICAL_REVIEW.has(stageValue)

  return {
    hasManualChange,
    stageValue,
    inWhitelist,
    shouldAdvance: hasManualChange && inWhitelist
  }
}
